module.exports = __webpack_public_path__ + "static/media/I Promise.a5760e14.jpg";